import React, { useEffect, useState,} from 'react';
import { useNavigate} from 'react-router-dom';
import classes from './main.module.css';
import {  Flex, Layout, Menu, Tag, } from 'antd';
import MainLogout from './MainLogout';
import {HomeOutlined,AppstoreAddOutlined,GlobalOutlined,NotificationOutlined,PayCircleOutlined,SettingOutlined,TeamOutlined,FileOutlined} from '@ant-design/icons';
import SuggestAdd from './SuggestAdd';
import { useDispatch, useSelector } from 'react-redux';
import { addTag, clickTag,deleteTag, resetMain } from '../store/tagSlice';
const { Content, Sider } = Layout;
 const items = [
        {
            key: '/SysHome',
            icon: <HomeOutlined />,
            label: '首页',
        },
        {
            key: 'develop',
            icon: <AppstoreAddOutlined />,
            label: '开发',
            theme:'light',
            popupOffset: [2, 0],
            children: [
                {
                    key: '/SysHome/SketchProject',
                    label: '效果图',             
                },     
                {
                    key: '/SysHome/ProjectTabs',
                    label: '后端任务',             
                },   
                {
                    key: 'require',
                    label: '需求',                
                    theme:'light',
                    children: [
                        {
                            key: '/SysHome/ModuleAdd',
                            label: '新增需求',                
                        },
                        {
                            key: '/SysHome/RequireTable',
                            label: '需求列表',                
                        }
                    ]
                },                     
               
                {
                    key: '1-8',
                    label: '规格',                
                },
            ],
        },
        {
            key: 'promotion',
            label: '推广',
            theme:'light',
            icon: <NotificationOutlined />,
            children: [
                {
                    key: '/wechat',
                    label: '微信',   
                    theme:'light',
                    children: [                        
                        {
                            key: '/SysHome/ContactList',
                            label: '客户名单',                
                        },
                        {
                            key: '/SysHome/ContactListAddFriend',
                            label: '加好友',                
                        },
                        {
                            key: '/SysHome/WorkWechatList',
                            label: '工作微信',                
                        }
                    ]
                },
                {
                    key: '/taobao',
                    label: '淘宝',        
                    theme:'light',
                    children: [
                        {
                            key: '/SysHome/TaobaoAdList',
                            label: '广告列表',                
                        },
                    ]
                },
                {
                    key: 'news',
                    label: '官网',      
                    theme:'light',
                    children: [
                        {
                            key: '/SysHome/NewsTypeList',
                            label: '新闻类型',                
                        },
                        {
                            key: '/SysHome/NewsList',
                            label: '新闻',                
                        }
                    ]             
                },       

                {
                    key: '/SysHome/MediaList',
                    label: '媒介',                
                },
                {
                    key: '/SysHome/PackageList',
                    label: '推广方案',                
                },
                {
                    key: '/SysHome/PublishList',
                    label: '广告发布',                
                },
                {
                    key: '/SysHome/FeedbackList',
                    label: '反馈',                
                },          
                                                                  
            ],
        },   
        {
            key: 'web',
            icon: <GlobalOutlined />,
            label: '销售',
            theme:'light',
            children: [           
                {
                    key: '/SysHome/WebGoodsTypeList',
                    label: '商品类型',                
                },  
                {
                    key: '/SysHome/WebGoodsList',
                    label: '商品',                
                },  
                {
                    key: '/SysHome/WebGoodsOrderList',
                    label: '订单',                                   
                },
                {
                    key: '/SysHome/ClientList',
                    label: '客户',                
                },     
                {
                    key: '/SysHome/TeachList',
                    label: '教程',
                    theme:'light',                    
                },                              
                {
                    key: 'ywz',
                    label: '旅当家2022',
                    theme:'light',           
                    children: [
                        {
                            key: '/SysHome/FirmAccount',
                            label: '账号',                
                        },
                        {
                            key: '/SysHome/FirmList',
                            label: '旅行社',                
                        },
                        {
                            key: '/SysHome/FirmSumBalance',
                            label: '统计报表',                
                        },
                        {
                            key: '/SysHome/FirmOrder',
                            label: '订单',                
                        },                
                        {
                            key: '/SysHome/AppPower?qx_type=2&name=旅当家电脑版权限',
                            label: '权限',                
                        },                
                        {
                            key: '/SysHome/YwzLedgerList',
                            label: '团队',                
                        },                
                        {
                            key: '/SysHome/YwzBalanceList',
                            label: '收支',                
                        },                
                    ],
                }, 
                {
                    key: 'lvdangjia2026',
                    label: '旅当家2026',  
                    theme:'light',
                    children: [                     
                        {
                            key: '/SysHome/QFirmList',
                            label: '企业列表',                
                        },                                             
                        {
                            key: '/SysHome/GoodsQuery',
                            label: '商品管理',                
                        },                                             
                        {
                            key: '/SysHome/GoodsOrderQuery',
                            label: '订单管理',                
                        },                                             
                    ]
                },
               
               
            ],
        },
        {
            key: 'finance',
            icon: <PayCircleOutlined />,
            label: '财务',
            theme:'light',
            children: [
                {
                    key: '/SysHome/BalanceElseList',
                    label: '收支流水',                
                },
                {
                    key: '/SysHome/BalanceTypeList',
                    label: '收支类型',                
                },
                {
                    key: '/SysHome/ArapAddOld',
                    label: '下账核销',                
                },
                {
                    key: '/SysHome/FundList',
                    label: '转账记录',                
                },                
                {
                    key: '/SysHome/Client',
                    label: '客户',                
                },                
                {
                    key: '/SysHome/GoodsList',
                    label: '产品',                
                },     
                {
                    key:'/SysHome/ExpenseList',
                    label:'费用报销单'
                },              
            ],
        },
                
        {
            key: 'team',
            icon: <TeamOutlined />,
            label: '工作任务',
            theme:'light',
            children: [
                {
                    key: '/SysHome/TaskAdd',
                    label: '新增工作任务',                
                },                             
                {
                    key: '/SysHome/TaskList',
                    label: '工作任务列表',                
                },                             
            ],
        }, 
        {
            key: '/SysHome/TechDocList',
            label: '文档',     
            icon: <FileOutlined />,
            theme:'light',
        },        
        {
            key: 'sys',
            icon: <SettingOutlined />,
            label: '设置',
            theme:'light',
            children: [
                {
                    key: '/SysHome/SetDept',
                    label: '部门用户',                
                },
                {
                    key: '/SysHome/SetRole',
                    label: '岗位',                
                },
                {
                    key: '/SysHome/MinePassword',
                    label: '修改密码',                
                },                          
            ],
        },
    ];
function Main(props) {
   const navigate = useNavigate();
    const dispatch = useDispatch();
    const mainTags = useSelector(state => state.tag?.value || []);
    const activeKey = useSelector(state => state.tag?.activeKey || '/SysHome');
    
    const [collapsed, setCollapsed] = useState(false);

    const onClick = (e) => {
        const menuItem = findMenuItemByKey(items, e.key);
        if (menuItem) {
            // 使用Redux action添加或激活标签
            const exists = mainTags.some(tag => tag.key === e.key);
            if (exists) {
                dispatch(clickTag(e.key));
            } else {
                dispatch(addTag({
                    key: e.key,
                    label: menuItem.label
                }));
            }
            // 导航会在useEffect中通过activeKey变化自动触发
        }
    };

    // 递归查找菜单项
    function findMenuItemByKey(menuItems, key) {
        for (const item of menuItems) {
            if (item.key === key) return item;
            if (item.children) {
                const found = findMenuItemByKey(item.children, key);
                if (found) return found;
            }
        }
        return null;
    }

    useEffect(() => {
        // 初始导航到当前激活的标签
        navigate(activeKey);
    }, [activeKey, navigate]);
    const navi = useNavigate()
    return (
        <Layout  style={{ minHeight: '100vh' }}>
             <Sider collapsible collapsed={collapsed} onCollapse={value => setCollapsed(value)}>
                <div style={{textAlign:'center',padding:"15px 0"}}>
                    <a 
                        href="/"
                        style={{
                                 fontSize:"20px",
                                 color:"#fff",
                              }}
                    >伯纳思</a>
                </div>
                <Menu 
                    theme="dark" 
                    selectedKeys={[activeKey]} 
                    mode="vertical"  
                    items={items}  
                    onClick={onClick} 
                    itemKey="key"
                />
            </Sider>
            <Layout>
                <div className={classes.mainHeader}>
                    {JSON.parse(localStorage.getItem('ed_name')) ?<div>
                        {/* <span>{localStorage.getItem('e_name').replace(/"/g,'')}</span> */}
                        {/* {(localStorage.getItem('e_name')!==localStorage.getItem('ed_name')) && <span><ApartmentOutlined /> {localStorage.getItem('ed_name').replace(/"/g,'')}</span>} */}
                        <span>{JSON.parse(localStorage.getItem('ed_name'))} / </span>                    
                        <MainLogout />
                    </div>:<a onClick={() => {navi('/Login')}}>登录</a>}                
                </div> 
                <Layout>                
                    <Layout>  
                        <Flex style={{ backgroundColor: "#fff", paddingLeft: "8px",paddingRight:"20px",paddingTop:"15px" }} justify='space-between'>
                            <div>
                                {mainTags.map((item) => (
                                        <Tag
                                            key={item.key}
                                            color={item.key === activeKey ? 'blue' : 'default'}
                                            style={{ cursor: 'pointer', marginRight: 8 }}
                                            closable={item.key !== '/SysHome'}
                                            onClose={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                // 使用Redux action删除标签
                                                dispatch(deleteTag(item.key));
                                            }}
                                        >
                                            <span 
                                                onClick={() => {
                                                    dispatch(clickTag(item.key));
                                                    // 导航会在useEffect中通过activeKey变化自动触发
                                                }}
                                                style={{ padding: '2px 5px' }}
                                            >
                                                {item.label}
                                            </span>
                                        </Tag>
                                    ))}
                           </div>
                           <a onClick={() => { 
                                dispatch(resetMain()); 
                                navigate('/SysHome'); 
                            }}>全部关闭</a>
                        </Flex>             
                        <Content className={classes.mainContent}>{props.children}</Content>
                        <div style={{textAlign:'right',margin:'0 30px 30px 0'}}>
                            <SuggestAdd />
                        </div>
                    </Layout>
                </Layout>     
            </Layout>
        </Layout>
    )

}
export default Main